function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M18.393 15.636v-7.09a2 2 0 0 0-2-2H7.666a2 2 0 0 0-2 2v4.352",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3 = React.createElement("path", {
  d: "M12.03 6.545v7.727M7.03 3.818c0 .91 2.727 1.818 5 1.818C11.574 4.424 10.392 2 9.301 2 7.94 2 7.03 2.91 7.03 3.818zM17.03 3.818c0 .91-2.728 1.818-5 1.818C12.483 4.424 13.665 2 14.756 2c1.363 0 2.272.91 2.272 1.818z",
  stroke: "#004152",
  strokeWidth: 1.5
});

var _ref4 = React.createElement("path", {
  d: "M2.03 18.364C4.757 19.727 9.302 22 9.757 22c.454 0 10.454-3.636 10.454-3.636h.002c.395-.138 1.313-.454 1.537-.679.602-.602-.034-2.033-1.852-2.033-1.455 0-3.713.976-5.077 1.431l-6.477.331",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref5 = React.createElement("path", {
  d: "M2.03 12.187c2.307.383 3.557.804 5.455 2.024h4.158c1.596 0 3.356.95 3.356 2.788",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift.5085ed95.svg";
export { ForwardRef as ReactComponent };